var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem-image-item"},_vm._l((_vm.itemPictures),function(data){return _c('img',{attrs:{"src":data.data,"alt":""},on:{"click":function($event){return _vm.$emit('pictureClick', data)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }